import React, { useEffect, useState } from "react";
import { Modal } from "antd";

import styles from "./styles/PhoneNumberButton.scss";
import ReactGA from "react-ga4";
import useHrPageName from "../../../utils/useHrPageName";
import { CallButton } from "./CallButton";
import { usePhoneReveal } from "../../../hooks/usePhoneReveal";
import TurnstileChallenge from "../../../components/TurnstileChallenge";

export interface PhoneNumberButtonProps {
  category: string;
  adId: string;
  hasPhones?: boolean;
  button?: React.JSXElementConstructor<{
    onClick: () => void;
    number: string;
  }>;
}

function PhoneNumberButton(props: PhoneNumberButtonProps) {
  const { category, adId, hasPhones, button: ButtonFromProps } = props;
  const [openModal, setOpenModal] = useState(false);
  const hrPageName = useHrPageName(category);
  const { state, phones, hardLimitMessage, reveal } = usePhoneReveal({ kind: "ad", id: adId });

  // After a successful reveal with multiple numbers, open the picker
  // modal immediately — the user came here to call, no reason to make
  // them click the button a second time to see the options. Hook must
  // stay above the early return so its call order is stable.
  useEffect(() => {
    if (state === "revealed" && phones.length > 1) {
      setOpenModal(true);
    }
  }, [state, phones.length]);

  if (!hasPhones) return null;

  const handleCall = () => {
    ReactGA.event({
      category: "Detalji oglasa",
      action: "Click",
      label: `Klik na telefon - ${hrPageName}`
    });

    if (state === "revealed" && phones.length > 0) {
      if (phones.length === 1) {
        document.location.href = `tel:${phones[0].number}`;
      } else {
        setOpenModal(true);
      }
      return;
    }
    reveal();
  };

  const primaryNumber = state === "revealed" && phones.length > 0 ? phones[0].number : null;

  return (
    <div>
      {state === "captchaRequired" ? (
        <TurnstileChallenge onSuccess={(token) => reveal(token)} />
      ) : state === "hardLimit" ? (
        <div className={styles.limitMessage}>
          {hardLimitMessage || "Prekoračili ste dnevni limit pregleda telefonskih brojeva. Pokušajte ponovno kasnije."}
        </div>
      ) : ButtonFromProps ? (
        <ButtonFromProps onClick={handleCall} number={primaryNumber} />
      ) : (
        <CallButton
          handleCall={handleCall}
          isShownButton={state === "revealed" && phones.length === 1}
          phoneNumber={primaryNumber}
          isLoading={state === "loading"}
        />
      )}
      <Modal
        visible={openModal}
        onCancel={() => setOpenModal(false)}
        footer={null}
        className={styles.modal}
      >
        <div className={styles.title}>
          {"Kontaktiraj oglašivača"}
        </div>
        <div className={styles.list}>
          {phones.map((phone, i) => (
            <div key={i} className={styles.phoneWrapper}>
              <span className={styles.phoneTitle}>
                {"Telefon"} {i + 1}:
              </span>
              <a href={`tel:${phone.number}`}>{phone.number}</a>
              {phone.name && <span className={styles.name}>{phone.name}</span>}
            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
}

export default PhoneNumberButton;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageWeb/PhoneNumberButton.tsx